import { useTranslation } from 'react-i18next';
import { PageHeader } from '@/shared/ui/layout/PageHeader';
import { Spinner } from '@/shared/ui/feedback/Spinner';
import { ErrorState } from '@/shared/ui/feedback/ErrorState';
import { extractErrorMessage } from '@/shared/api/errors';
import { useLimitConfig } from '@/entities/limit-config';
import { usePricingConfig } from '@/entities/pricing';
import { FeaturesPricingPricingForm } from '@/features/pricing';

export const WidgetsPricingMain = () => {
  const { t } = useTranslation();
  const limitQuery = useLimitConfig();
  const pricingQuery = usePricingConfig();

  const error = limitQuery.error ?? pricingQuery.error;

  return (
    <>
      <PageHeader title={t('pricing.title')} subtitle={t('pricing.subtitle')} />
      <div className="mx-auto w-full max-w-3xl space-y-4 px-4 py-4 lg:px-6 lg:py-6">
        {error ? (
          <ErrorState
            message={extractErrorMessage(error, t('pricing.loadError'))}
            onRetry={() => {
              void limitQuery.refetch();
              void pricingQuery.refetch();
            }}
          />
        ) : limitQuery.data && pricingQuery.data ? (
          <FeaturesPricingPricingForm limit={limitQuery.data} pricing={pricingQuery.data} />
        ) : (
          <div className="flex justify-center py-16">
            <Spinner />
          </div>
        )}
      </div>
    </>
  );
};
